let routes = [
  {
    path: '/demande-accreditation-mediation-familiale',
    component: () => import('../views/AccreditationMediationFamiliale.vue'),
    props: true
  },
  {
    path: '/demande-accreditation-mediation-familiale/:step',
    component: () => import('../views/AccreditationMediationFamiliale.vue'),
    props: true
  }
]

export default routes;